import { ClipLoader } from "react-spinners";
import React from "react";

const DownloadingDocument = (props: any) => {
    return (
        <div
            className={props.selectedStyle}
            style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                backgroundColor: "#B4B4B4"
            }}
        >
            <ClipLoader color={"#ffffff"} loading={true} size={"50px"} />
        </div>
    );
};

export default DownloadingDocument;
